import { render, staticRenderFns } from "./MarketingWhatsapp.vue?vue&type=template&id=c2300bcc&scoped=true"
import script from "./MarketingWhatsapp.vue?vue&type=script&lang=js"
export * from "./MarketingWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2300bcc",
  null
  
)

export default component.exports